import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { clearState } from "../store/localStorage";

const HelpModal = ({ isOpen }) => {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [isOpen]);

  const handleCloseModal = () => {
    clearState();
    navigate("/");
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 sm:px-6">
          {/* Backdrop */}
          <motion.div
            className="absolute inset-0 bg-black/40 backdrop-blur-sm"
            onClick={handleCloseModal}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          />

          {/* Modal */}
          <motion.div
            className="relative z-10 w-full max-w-xl bg-white shadow-2xl
                       rounded-2xl sm:rounded-3xl
                       p-5 sm:p-8
                       max-h-[85vh] overflow-y-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
          >
            <h2 className="text-xl sm:text-3xl font-bold text-text-primary">
              Help is available
            </h2>
            <p className="text-border-extrabold text-base sm:text-lg mb-5 sm:mb-8">
              Speak with someone today
            </p>

            <div className="space-y-4 sm:space-y-6 mb-6 sm:mb-8">
              <div>
                <h3 className="font-bold text-text-primary text-base sm:text-lg mb-1">
                  For immediate mental health crisis support in NYC
                </h3>
                <p className="text-black text-sm sm:text-base leading-relaxed">
                  Call or text 988 to reach the 988 Suicide &amp; Crisis Lifeline for
                  24/7 confidential help.
                </p>
              </div>

              <div>
                <h3 className="font-bold text-text-primary text-lg mb-1">Contact NYC Well</h3>
                <p className="text-black leading-relaxed">
                  At 888-NYC-WELL (888) 111-3342 for comprehensive services, including text/chat options for mental health and substance use support.
                </p>
              </div>
            </div>

            <div className="flex justify-center">
              <button
                onClick={handleCloseModal}
                className="w-full sm:w-auto rounded-xl bg-primary
                           px-6 sm:px-12 py-3
                           text-white font-semibold text-base sm:text-lg
                           hover:bg-primary-hover transition shadow-md"
              >
                Close
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default HelpModal;
